import PropTypes from 'prop-types';
import React, { useCallback, useState } from 'react';

const delayChange = 650;
let timerCellChange = null;

export default function TableTextInput({em, data, datalist, inputClass, onChange, onBlur}) {
  const [textValue, setTextValue] = useState(data && em.field && (data[em.field] || ''))
  const originalText = data && em.field && (data[em.field] || '');

  let isDisabled = em.readOnly;
  if (em.enableBy) {
    const criteria = em.enableBy.split(':');
    const _fld = criteria[0];

    if (data[_fld]) {
      if (criteria.length > 1) {
        isDisabled = data[_fld].match(new RegExp(criteria[1], 'i')) ? false : true;
      } else {
        isDisabled = (data[_fld]===true || data[_fld].match(/1|A|Y/i)) ? true : false;
      }
    }
  }

  if (em.disableBy) {
    const criteria = em.disableBy.split(':');
    const _fld = criteria[0];

    if (data[_fld]) {
      if (criteria.length > 1) {
        isDisabled = data[_fld].match(new RegExp(criteria[1], 'i')) ? true : false;
      } else {
        isDisabled = (data[_fld]===true || data[_fld].match(/1|A|Y/i)) ? true : false;
      }
    }
  }

  const handleTextChange = useCallback(
    (e) => {
      e.preventDefault();
      if (timerCellChange) clearTimeout(timerCellChange);

      setTextValue(e.target.value);
      // DO NOT USE DELAY CHANGE, it affect updating
      const _hasChanged = e.target.value !== originalText;
      if (! _hasChanged) return;

      timerCellChange = setTimeout(() => {
        if (onChange) onChange(e);
      }, delayChange);
      //
    },
    [originalText, onChange]
  );

  const handleKeyUp = useCallback(
    (e) => {
      if (e.key.match(/^tab$/i)) return;
      
      onChange({
        target: { name: null }, 
      });
    },
    [onChange],
  )
    
  const handleTextBlur = useCallback(
    (e) => {
      e.preventDefault();
      if (timerCellChange) clearTimeout(timerCellChange);
      // console.info('TextBlur...', e.target.value, originalText);
      if (onBlur) onBlur(e); // Always call onBlur

      const _hasChanged = e.target.value !== originalText;
      if (! _hasChanged) return;

      onChange(e);
    },
    [originalText, onChange, onBlur],
  )
  
  return (
    <input
      className={`form-control ${inputClass}`}
      name={em.field}
      value={textValue} // value={data && em.field && (data[em.field] || '')}
      // eslint-disable-next-line react/prop-types
      onChange={handleTextChange} // onChange={onChange}
      onBlur={handleTextBlur}
      onKeyUp={handleKeyUp}
      // eslint-disable-next-line react/prop-types
      list={em.datalist || datalist}
      autoComplete="off"
      readOnly={em.readOnly || isDisabled}
    />
  )
}

TableTextInput.propTypes = {
  em: PropTypes.any,
  data: PropTypes.any,
  datalist: PropTypes.any,
  inputClass: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
}